import { AbstractControl, FormArray, FormControl } from '@angular/forms';

export interface CalendarForm<T extends FormArray<AbstractControl>> {
  [CalendarFormKey.Users]: FormArray<FormControl<string | null>>;
  [CalendarFormKey.Templates]: T;
}

export enum CalendarFormKey {
  Users = 'shiftPlanUsers',
  Templates = 'shiftPlanTemplates',
}
